import { combineReducers } from 'redux';
import callbacks from './callbacks/reducer.tsx';
import context from './context/reducer.tsx';
import ui from './ui/reducer.tsx';

const combinedReducer = combineReducers({
	ui,
	callbacks,
	context,
});
export default combinedReducer;
